import { createContext, useContext, useEffect, useState } from "react";
import { apiFetch } from "@/lib/api";

const DashboardContext = createContext(null);

export const DashboardProvider = ({ children, stateKey }) => {
    const [data, setData] = useState(null);
    const [stateMeta, setStateMeta] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError(null);
        setData(null);
        setStateMeta(null);

        const load = async () => {
            try {
                const json = await apiFetch(`/api/dashboard/states/${encodeURIComponent(stateKey)}`);

                if (active) {
                    setStateMeta({
                        state_id: json?.entity?.state_id,
                        state_name: json?.entity?.state_name,
                        slug: String(stateKey),
                    });
                    setData(json);
                    setLoading(false);
                }
            } catch (e) {
                if (active) {
                    setError(e.message || "Unable to load dashboard data.");
                    setLoading(false);
                }
            }
        };

        load();
        return () => {
            active = false;
        };
    }, [stateKey]);

    return (
        <DashboardContext.Provider value={{ data, stateMeta, stateKey, error, loading }}>
            {children}
        </DashboardContext.Provider>
    );
};

export const useDashboard = () => {
    const ctx = useContext(DashboardContext);
    if (!ctx) throw new Error("useDashboard must be used within DashboardProvider");
    return ctx;
};
